<template>
  <transition>
  <!-- 一覧 -->
  <div key=1 class="chat-box" v-if="!isDetail&&!isStoryView">
    <RoboContent
      :color="color"
      :widgetData="widgetData"
      :data="data"
      :selectTagNewMsg="selectTagNewMsg"
      @openChatBot="openChatBot"
      @changeView="changeView"
      v-if="widgetData.bots.length > 0"
    />
    <StoryContent
      :color="color"
      :widgetData="widgetData"
      @openNovel="openPage"
      @changeView="changeView"
      v-if="widgetData.story.length > 0"
    />
    <RecruitContent
      :color="color"
      :widgetData="widgetData"
      @openRecruit="openPage"
      @changeView="changeView"
      v-if="widgetData.recruit.length > 0"
    />
    <CustomContent
      :color="color"
      :widgetData="widgetData"
      @openCustom="openPage"
      @changeView="changeView"
      v-if="widgetData.custom.length > 0"
    />
    <CompanyPageContent
      :color="color"
      :widgetData="widgetData"
      @openCompanyPage="openPage"
      @changeView="changeView"
      v-if="widgetData.homepages.length > 0"
    />
    <!-- 表示できるコンテンツがない場合 -->
    <template v-if="isNoContent()">
      <div class="no-content">
        <b-message type="is-info" has-icon>
          大変申し訳ございませんが
          表示できるコンテンツがございません。
        </b-message>
      </div>
    </template>
  </div>
  <!-- ロボ/ノベル 一覧 -->
  <div key=2 class="chat-box" v-else-if="isDetail&&!isStoryView">
    <RoboContentList
      :color="color"
      :widgetData="widgetData"
      :data="data"
      :selectTagNewMsg="selectTagNewMsg"
      @openChatBot="openChatBot"
      @changeView="changeView"
      v-if="viewType === 'bot'"
    />
    <StoryContentList
      :color="color"
      :widgetData="widgetData"
      @openNovel="openPage"
      @changeView="changeView"
      v-else-if="viewType === 'story'"
    />
  </div>
  <!-- ページビュー -->
  <div key=3 class="chat-box" v-else-if="!isDetail&&isStoryView">
    <div class="-menu">
      <a @click="changeView(false, false, null)"><span class="mdi mdi-chevron-left -right-4px"></span>戻る</a>
    </div>
    <div
      id="hr-monster-original-widget"
      class="widget-frame">
      <iframe
        id="hr-monster-iframe"
        frameboader="0"
        :src="pageURL">
      </iframe>
      <div style="width: 100%; height: 100%; position: overflow: hidden; absolute; top: 0; left: 0;" v-if="isLoading">
        <span class="mdi mdi-loading mdi-spin mdi-48px"></span>ページを読み込んでいます
      </div>
    </div>
  </div>
  </transition>
</template>

<script>
import RoboContent        from '@/components/ChatWidgetDialog/organisms/RoboContent'
import RoboContentList    from '@/components/ChatWidgetDialog/organisms/RoboContentList'
import StoryContent       from '@/components/ChatWidgetDialog/organisms/StoryContent'
import StoryContentList   from '@/components/ChatWidgetDialog/organisms/StoryContentList'
import RecruitContent     from '@/components/ChatWidgetDialog/organisms/RecruitContent'
import CustomContent      from '@/components/ChatWidgetDialog/organisms/CustomContent'
import CompanyPageContent from '@/components/ChatWidgetDialog/organisms/CompanyPageContent'
import resetLocalStorageSeeker from '@/functions/resetLocalStorageSeeker'

export default {
  components: {
    RoboContent,
    RoboContentList,
    StoryContent,
    StoryContentList,
    RecruitContent,
    CustomContent,
    CompanyPageContent
  },
  props: {
    color: {
      type: Object,
      required: true
    },
    widgetData: {
      type: Object,
      required: true
    },
    targetID: {
      type: String,
      required: true
    },
    seeker: {
      type: Object,
      required: true
    },
    data: {
      type: Object,
      required: true
    },
    selectTagNewMsg: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      selectIndex: 0,
      isDetail: false,
      isStoryView: false,
      viewType: null,
      pageURL: null,
      isLoading: false,
    }
  },
  watch: {
    isLoading () {
      if (this.isLoading) {
        setTimeout(() => {
          this.isLoading = false
        }, 3000)
      }
    }
  },
  methods: {
    changeView (data) {
      this.isDetail = data.isDetail
      this.isStoryView = data.isStoryView
      this.viewType = data.viewType
      // ノベルの時はローディングを付与
      this.isLoading = data.isStoryView
      if (this.isLoading) {
        this.iframeReload()
      }
    },
    getIcon (bot) {
      if (bot.icon_data) {
        return bot.icon_data
      } else {
        return require('@/assets/template/robot.png')
      }
    },
    makeColor () {
      return {
        'color': this.color.iconBg + '!important'
      }
    },
    openPage (url) {
      this.pageURL = url + '?' + String(new Date().getTime())
    },
    iframeReload () {
      this.$nextTick(() => {
        document.getElementById('hr-monster-iframe').contentWindow.location.reload(true)
        document.getElementById('hr-monster-iframe').src = document.getElementById('hr-monster-iframe').src
      })
    },
    openChatBot (data) {
      this.$emit('openCB',
        data.bot.header_title,
        data.bot.bot_header_type
      )
      this.botIndex = data.idx
      this.bot = data.bot
      this.$store.dispatch('directtalk/setDT', {
        name: data.bot.display_name,
        icon: data.bot.icon_data,
        id:   data.bot.bot_id,
        model: 'bot'
      })
      this.$store.dispatch('chatbot/setMiniPK', data.bot.pk || null)
      this.$store.dispatch('directtalk/createSeekerATHistory', {
        target: data.bot.display_name,
        action: 'click_room',
        url: this.data.url,
        element: 'button'
      })
      this.createSKTagHistory('click_room', data.bot.tag)
      let id = data.bot.pk || data.bot.bot_id
      let lv = localStorage.getItem('scenariolv_' + id)
      if (lv) {
        lv = JSON.parse(lv)
        if (lv.node == '') {
          lv = null
          localStorage.removeItem('scenariolv_' + id)
        }
      }
      if (!lv) {
        resetLocalStorageSeeker(this.seeker.id)
        this.$store.dispatch('chatbot/getScenarioOne', {
          companyid: this.data.ckey,
          scenarioName: data.bot.scenario_name,
          node: 'INITIALIZE',
          rate: this.color.thinking_rate,
          minipk: data.bot.pk ? data.bot.pk : null
        })
      }
      this.$store.commit('chatbot/SET_LAST_VIEW', lv)
      this.$emit('changeModalDialog')
    },
    createSKTagHistory (action_name, tag) {
      const tempSeekerTagHistory = {
        seeker: this.seeker.pk,
        action_name: 'click_room',
        url: this.data.url,
        tag: tag
      }
      this.$store.dispatch('directtalk/createSeekerTagHistory', tempSeekerTagHistory)
    },
    getBackgroundStory (story) {
      if (story.icon_data) {
        // オリジナル画像から使う
        return story.icon_data
      } else {
        // デフォルト画像から使う
        return require('@/assets/scene/' + story.icon_type + '.jpg')
      }
    },
    tagsList (tags) {
      if (tags === null) {
        return []
      } else {
        const arr = tags.split(',')
        arr.pop()
        return arr
      }
    },
    isNoContent () {
      // コンテンツの有無を確認
      return this.widgetData.bots.length      === 0
        &&   this.widgetData.story.length     === 0
        &&   this.widgetData.recruit.length   === 0
        &&   this.widgetData.custom.length    === 0
        &&   this.widgetData.homepages.length === 0
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.chat-box {
  position: relative !important;
  height: 100%;
  width:  100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  overflow: auto;
  padding: 8px 0px;
  .no-content {
    padding: 16px;
  }
  .-menu {
    width: 94%;
    text-align: left;
    padding: 8px;
    padding-top: 0;
    position: fixed;
    z-index: 10;
    background: #f4f5f6;
  }
  .widget-frame {
    margin-top: 33px;
    position: relative;
    width: 100%;
    height: calc(100% - 33px);
    padding-top: 56.25%;
    overflow: auto;
    -webkit-overflow-scrolling:touch;
    border: 2px solid transparent;
    iframe {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      border: none;
      display: block;
    }
  }
}

.v-enter-active, .v-leave-active {
  transition: .5s
}
.v-enter, .v-leave {
  transform: translateY(100%);
  position: absolute;
}
</style>



// WEBPACK FOOTER //
// src/views/ChatWidget/SelectMenu.vue